// import React, { createContext, useContext, useState } from 'react';
// import { ALERT_TIMEOUT } from 'utils/constants';
// import Alert from 'components/Common/Alert';

// const AlertContext = createContext();

// export const AlertProvider = ({ children }) => {
//   const [alert, setAlert] = useState({ message: '', type: '', show: false });

//   const showAlert = (message, type = 'info') => {
//     setAlert({ message, type, show: true });
//     setTimeout(() => setAlert(prev => ({ ...prev, show: false })), ALERT_TIMEOUT); 
//   };

//   const hideAlert = () => {
//     setAlert(prev => ({ ...prev, show: false }));
//   };

//   return (
//     <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
//       {children}
//       <Alert />
//     </AlertContext.Provider>
//   );
// };

// export const useAlert = () => useContext(AlertContext);

import React, { createContext, useContext, useState } from 'react';
import { ALERT_TIMEOUT, DETAIL_ALERT_TIMEOUT } from 'utils/constants';
import Alert from 'components/Common/Alert';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({ message: '', type: '', show: false, detail: null });

  const showAlert = (message, type = 'info', detail = null) => {
    setAlert({ message, type, show: true, detail });
    const timeoutDuration = detail ? DETAIL_ALERT_TIMEOUT : ALERT_TIMEOUT;
    setTimeout(() => setAlert(prev => ({ ...prev, show: false })), timeoutDuration);
  };

  const hideAlert = () => {
    setAlert(prev => ({ ...prev, show: false }));
  };

  return (
    <AlertContext.Provider value={{ alert, showAlert, hideAlert }}>
      {children}
      <Alert />
    </AlertContext.Provider>
  );
};

export const useAlert = () => useContext(AlertContext);